import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { StyledContainer, ArrowCircle } from "./style";

type ArrowLinkProps = {
  to: string;
  text?: string;
  ariaLabel?: string;
  onClick?: () => void;
};

const ArrowLink: React.FC<ArrowLinkProps> = ({
  to,
  text,
  ariaLabel,
  onClick,
}) => (
  <StyledContainer
    to={to}
    data-test-id="arrow-link"
    aria-label={ariaLabel}
    onClick={onClick}
  >
    <ArrowCircle>
      <FontAwesomeIcon icon={faArrowRight} />
    </ArrowCircle>
    {text}
  </StyledContainer>
);

export default ArrowLink;
